import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useUser } from '../lib/UserContext';
import '../css/Reporte.css';


function ReporteIngresos() {
  const [filteredIngresos, setFilteredIngresos] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const { currentUser } = useUser();

  const id_usuario = currentUser?.id; 
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!id_usuario) {
      console.error('No hay usuario autenticado');
      return;
    }

    axios.get(`${apiUrl}/Donantes/Donaciones/Identificacion/${id_usuario}`)
      .then((response) => {
        setFilteredIngresos(response.data);
        console.info('Donaciones cargadas:', response.data);
      })
      .catch((error) => {
        console.error('Error al obtener los ingresos:', error);
      });
  }, [apiUrl, id_usuario]);



  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const sortedIngresos = [...filteredIngresos].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredIngresos(sortedIngresos);
    setSortConfig({ key, direction });
  };

  // Función para formatear valores monetarios sin decimales
  const formatCurrency = (value) => {
    return Number(value).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP', // Cambia a tu moneda si es necesario
      minimumFractionDigits: 0, // No mostrar decimales
      maximumFractionDigits: 0, // No mostrar decimales
    });
  };

  // Calcular el total de las donaciones
  const calcularTotal = () => {
    return filteredIngresos.reduce((total, ingreso) => {
      return total + (Number(ingreso.valor) || 0);
    }, 0);
  };

  return (
    <div className="reporte-container">
      <div className="reporte-content">

        <div className="table-wrapper">
          <div className="search-container">
            <h1 className="reporte-ingresos-title">Reporte de Donaciones</h1>

          </div>
          <div className="table-responsive">
            <table className="ingresos-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('identificacion')}>Identificación</th>
                  <th onClick={() => handleSort('nombres')}>Nombres</th>
                  <th onClick={() => handleSort('apellidos')}>Nombres</th>
                  <th onClick={() => handleSort('concepto')}>Concepto</th>
                  <th onClick={() => handleSort('fechaDonacion')}>Fecha Ingreso</th>
                  <th onClick={() => handleSort('valor')}>Valor</th>
                </tr>
              </thead>
              <tbody>
                {filteredIngresos.map((ingreso) => (
                  <tr key={ingreso.id}>
                    <td data-label="Identificación">{ingreso.identificacion}</td>
                    <td data-label="Nombres">{ingreso.nombres}</td>
                    <td data-label="Apellidos">{ingreso.apellidos}</td>
                    <td data-label="Concepto">{ingreso.concepto}</td>
                    <td data-label="Fecha Donación">{new Date(ingreso.fechaDonacion).toLocaleDateString()}</td>
                    <td data-label="Valor">{formatCurrency(ingreso.valor)}</td>
                   
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td colSpan="5" className="total-label">Total Donaciones:</td>
                  <td className="total-value">{formatCurrency(calcularTotal())}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReporteIngresos;
